export const getDiscountCouponList = state => {
    return state.list
}

export const getDiscountCouponDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/discountCoupon/getters.js